import { addItemToWorkflowTable, removeItemFromWorkflowTable } from '@/warehouse/helpers';
export function updatePickingTasksByMessage(draft, message, isPickedTab) {
    const task = message.task;
    const itemIndex = draft.findIndex((item) => item.id === task.id);
    const isFullyPicked = task.quantity === task.pickedQuantity + task.blockedQuantity;
    if (isPickedTab) {
        if (isFullyPicked) {
            if (itemIndex === -1) {
                addItemToWorkflowTable(draft, task, 'id');
            }
            else {
                // Is it possible to get this case?
                draft[itemIndex].quantity = task.quantity;
                draft[itemIndex].pickedQuantity = task.pickedQuantity;
                draft[itemIndex].blockedQuantity = task.blockedQuantity;
            }
        }
        else {
            if (itemIndex !== -1) {
                removeItemFromWorkflowTable(draft, itemIndex);
            }
        }
    }
    // Not picked tab
    else {
        if (isFullyPicked) {
            if (itemIndex !== -1) {
                removeItemFromWorkflowTable(draft, itemIndex);
                // May be better marked as disabled? Because will not still be red with some blocked items inside.
            }
        }
        else {
            if (itemIndex === -1) {
                addItemToWorkflowTable(draft, task, 'id');
            }
            else {
                draft[itemIndex].quantity = task.quantity;
                draft[itemIndex].pickedQuantity = task.pickedQuantity;
                draft[itemIndex].blockedQuantity = task.blockedQuantity;
            }
        }
    }
}
